import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {}

interface Variables {
    leadId: string,
}

export const INVITE_LEAD: TypedDocumentNode<Result, Variables> = gql`
    mutation SendLeadInvitation($leadId: Int){
        sendLeadInvitation (leadId: $leadId)
    }       
`
